import { organizationType } from "const/nuclias/organization";

import smsConfigExtension from "./extensions/SmsConfig";

class SmsConfigModel {
  static accountState;

  id = 0;
  checked = false;
  name = '';
  accessLevelType = '';
  accessLevelLabel = '';
  managedSite = '';
  managedSiteTag = '';
  managedSiteList = [];
  managedSiteSearchList = [];
  twilioAccountSid = '';
  twilioFromNumber = '';
  resendAfter = '';
  maximumResend = '';
  maximumRequest = '';
  denialPeriod = '';
  OtpExpiresIn = '';
  allowedPhonePrefix = '';
  rawData = {};

  constructor(rawData, orgTreeMap, selectedOrg) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.accessLevelType = (this._setAccessLevel(rawData.storeTagId, rawData.storeId)).type;
    this.accessLevelLabel = (this._setAccessLevel(rawData.storeTagId, rawData.storeId)).label;
    this.twilioAccountSid = rawData.twilioClientId || '';
    this.twilioFromNumber = rawData.twilioFromNumber || '';
    this.resendAfter = rawData.smsResendAfter || '';
    this.maximumResend = rawData.smsResendNumber || '';
    this.maximumRequest = rawData.smsRequestNumber || '';
    this.denialPeriod = rawData.smsDenialPeriod || '';
    this.OtpExpiresIn = rawData.smsExpiresIn || '';
    this.allowedPhonePrefix = rawData.smsAllowedPhonePrefix.join(',');
    this.rawData = rawData;

    const { managedSiteTag, managedSite, managedSiteList } = this._setAccessaLevelScope(rawData.storeTagId, rawData.storeId, orgTreeMap, selectedOrg);
    this.managedSiteTag = managedSiteTag;
    this.managedSite = managedSite;
    this.managedSiteList = managedSiteList;

    managedSiteList.map(site => this.managedSiteSearchList.push(site.site));
  }

  _setAccessLevel(siteTagId, siteId) {
    let accessLevel = {
      type: null,
      label: null
    };

    if (siteTagId) {
      accessLevel.type = organizationType.tag;
      accessLevel.label = '3039a00fca';
    } else if (siteId) {
      accessLevel.type = organizationType.site;
      accessLevel.label = 'a7d6475ec8';
    } else {
      accessLevel.type = organizationType.org;
      accessLevel.label = 'd6b258792f';
    }

    return accessLevel;
  }

  _setAccessaLevelScope(siteTagId, siteId, orgTreeMap, selectedOrg) {
    let managedSiteTag = '';
    let managedSite = '';
    const managedSiteList = [];

    if (siteTagId) {
      managedSiteTag = selectedOrg.storeTagObj[siteTagId.toString()].name;
      let id = 0;
      for (const _siteId in orgTreeMap.withStore) {
        if (orgTreeMap.withStore[_siteId].indexOf(siteTagId) > 0) {
          managedSiteList.push({
            id,
            site: selectedOrg.storeObj[_siteId].name
          });

          id++;
        }
      }
    } else if (siteId) {
      managedSite = selectedOrg.storeObj[siteId.toString()].name;
      managedSiteList.push({
        id: 0,
        site: managedSite
      });
    } else {
      let id = 0;
      for (const _siteId in selectedOrg.storeObj) {
        managedSiteList.push({
          id,
          site: selectedOrg.storeObj[_siteId].name
        });

        id++;
      }
    }

    return {
      managedSiteTag,
      managedSite,
      managedSiteList
    };
  }
}

for (const funcName in smsConfigExtension) {
  SmsConfigModel[funcName] = smsConfigExtension[funcName];
}

export default SmsConfigModel;